/**
 * Booking Operations Module
 * 
 * This module provides a unified system for handling all booking-related operations
 * across the application, including creation, updates, cancellations, approvals, and rejections.
 */

// Main exports
export { BookingOperationsProvider, useBookingOperations as useBookingOps } from './BookingOperationsContext';
export { useBookingOperations, useBookingCallback, useBookingSubscriptionStatus } from './useBookingOperations';
export { bookingOperationsService, BookingOperationsService } from './bookingOperationsService';

// Types and constants
export {
  PROCESSING_RESULTS,
  BOOKING_OPERATIONS,
  NOTIFICATION_TYPES,
  OPERATION_STATUS,
  DEFAULT_MESSAGES,
  createCallbackConfig
} from './types';

// Re-export commonly used values for convenience
export const BookingOperations = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  CANCEL: 'CANCEL',
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  CHECK_IN: 'CHECK_IN',
  DELETE: 'DELETE',
};

// Helper function for quick setup
// Note: This returns the configuration object, not the actual provider
// Usage: const config = setupBookingOperations(mutations);
export const setupBookingOperations = (mutations = {}) => {
  return {
    mutations,
  };
};